import React from 'react'
import Link from 'gatsby-link'
import { Spin, message } from 'antd'
import axios from 'axios'

class ContactPage extends React.Component {

  constructor() {
    super();
    this.state = {
      processing: false,
      sent: false,
      name: '',
      email: '',
      message: '',
    };
    this.inputChange = this.inputChange.bind(this);
    this.submit = this.submit.bind(this);
  }


  inputChange(field, event) {
    this.setState({ [field]: event.target.value });
  }


  validateEmail( email_address ) {
    const email_validator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if ( email_validator.test(email_address) ) {
      return true;
    } else {
      return false;
    }
  }


  submit(e) {
    e.preventDefault();

    if ( ! this.state.name || ! this.state.email || ! this.state.message ) {
      return message.info('You must enter your Name, Email and the Message.');
    }

    if ( ! this.validateEmail( this.state.email ) ) {
      return message.error('Please enter a valid email address.');
    }

    this.setState({ processing: true });

    axios.post(
      'https://hook.io/dhruv-dhruvkumarjha-com/process-form',
      {
        name: this.state.name,
        email: this.state.email,
        message: this.state.message,
      }
    )
    .then( (response) => {
      this.setState({ processing: false, sent: true, name: '', email: '', message: '' });
      message.success('Your message has been successfully sent.', 4);
    })
    .catch( (error) => {
      this.setState({ processing: false });
      message.error('Some error occoured while sending message., Please try again.');
    });

  }


  render() {

    return (
      <div className="page--contact">

        <h1>Want to get in touch with Me? Just Fill the form below</h1>
        <p>You can use this form to Say Hi, Give your feedback, Ask for tutorials, Discuss about projects and etc.</p>


        <Spin spinning={ this.state.processing } size="large" tip="Sending message...">
        <form className="default" onSubmit={ this.submit }>

          <div className="input">
            <label htmlFor="name">Full Name</label>
            <input type="text" id="name" placeholder="John Doe" value={this.state.name} autoFocus={true} onChange={ (event) => { this.inputChange('name',event) } } />
          </div>
          <div className="input">
            <label htmlFor="email">Email Address</label>
            <input type="text" id="email" placeholder="john.doe@gmail.com" value={this.state.email} onChange={ (event) => { this.inputChange('email',event) } } />
          </div>
          <div className="input">
            <label htmlFor="message">Your Message</label>
            <textarea type="text" id="message" placeholder="Please enter your message here..." value={this.state.message} onChange={ (event) => { this.inputChange('message',event) } } ></textarea>
          </div>

          <button type="submit" className="button">Send Message</button>

        </form>
        </Spin>



      </div>
    );

  }


}


export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js